import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import { pipViewDate } from "../../../utils/pip";
import { adminPaths } from "../../../routes/admin";
import AdminLayout from "../../../layouts/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/form/NoRecord";
import StatusCol from "../../../components/table/StatusCol";
import TableHeader from "../../../components/table/tableHeader";
import ReactPagination from "../../../components/table/ReactPagination";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import AddProject from "../../../components/Modals/common/project/AddEditProject";
import ProjectDetails from "../../../components/Modals/common/project/ProjectDetails";
import { setIsViewProjectDetails } from "../../../redux/features/admin/reducers/projectReducer";
import ProjectJobFilter from "../../../components/pages/admin/modals/ProjectFilter/ProjectJobFilter";
import {
  addAdminProjectDetails,
  fetchAdminProject,
  fetchProjectDetails,
  fetchProjectUploadeableDetails,
  markAdminProjectComplete,
  updateProjectStatus,
  uploadDocumentByAdmin,
} from "../../../redux/features/admin/actions/projectAction";
import MarkCompleteConfirmationModal from "../../../components/Modals/hire-talent/MarkCompleteConfirmationModal";
import MarkAsCompleteModal from "../../../components/Modals/hire-talent/MarkAsCompleteModal";
import UploadDeliveableModal from "../../../components/Modals/hire-talent/UploadDeliveableModal";
import { SocketBootstrap } from "../../../components/chat/SocketBootstrap";

const JobProjects = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, projectList, projectHeader, isViewProjectDetails } =
    useSelector((state) => state?.admin?.project);
  const { deliveableList } =
    useSelector((state) => state?.admin?.project);
  const [projectId, setProjectId] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [isSuccess, setIsSuccess] = useState("");
  const [selectProject, setSelectProject] = useState('');
  const [isUpload, setIsUpload] = useState(false);

  const tabs = [
    {
      lable: "All Project & Jobs",
      value: "all",
    },
    {
      lable: "Funding Project",
      value: "funding",
    },
    {
      lable: "Service Project",
      value: "service",
    },
    {
      lable: "Job Post",
      value: "job_post",
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const [isAddProject, setIsAddProject] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);

  const paginatedList =
    projectList[activeTab]?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  useEffect(() => {
    dispatch(fetchAdminProject());
    return () => {
      dispatch(setIsViewProjectDetails(false));
    };
  }, []);

  const handleUpdateStatus = (value, item) => {
    const callback = (response) => {
      dispatch(fetchAdminProject());
    };
    const data = {
      project_id: item?.id,
      action: value,
    };
    dispatch(updateProjectStatus({ payload: data, callback }));
  };

  const handleEditAddroject = (values) => {
    const callback = (response) => {
      setIsAddProject(false);
      dispatch(fetchAdminProject());
    };
    dispatch(addAdminProjectDetails({ payload: values, callback }));
  };

  const handleMarkAsComplete = (project_id) => {
    const callback = (res) => {
      if (res?.success) {
        setIsSuccess(true);
        dispatch(fetchAdminProject());
      } else {
        setIsSuccess(false);
      };
    };
    dispatch(
      markAdminProjectComplete({
        payload: { project_id },
        callback,
      })
    );
  };

  const handleUploadDeliveablesData = (values) => {
    const callback = (response) => {
      setIsUpload(false);
      dispatch(fetchAdminProject());
    };
    const formData = new FormData();
    formData.append("project_id", selectProject);
    values.comment && formData.append("comment", values.comment);
    values.link && formData.append("links", values.link);
    values?.files?.length != 0 &&
      values?.files?.map((item) => (
        formData.append("files", item)
      ))
    dispatch(uploadDocumentByAdmin({ payload: formData, callback }));
  };

  if (isLoading) {
    return <Loader />;
  };
  return (
    <AdminLayout>
      <SocketBootstrap role="admin" />
      <div className="ct_px_40 mt-4">
        <div className="row">
          <ProjectJobFilter />
          <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
              <div>
                <h4 className="mb-0 ct_fs_20  mb-0">
                  Project & Jobs Management
                </h4>
                <p className="mb-0 ct_text_clr_757886">
                  Review and track all project submissions, status and activity
                </p>
              </div>
              <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                <div className="position-relative ct_w_100_575">
                  <input
                    type="text"
                    className="form-control ct_input ct_h_35 ps-5"
                    placeholder="Search by Title"
                  />
                  <i className="fa-solid fa-search ct_input_icon_left"></i>
                </div>
                <button
                  className="ct_yellow_btn ct_h_35 ct_w_100_575"
                  onClick={() => {
                    setIsAddProject(true);
                  }}
                >
                  Add New Project
                </button>
              </div>
            </div>
            <ul className="ct_table_filter">
              {tabs?.map((item, ind) => (
                <li
                  style={{ cursor: "pointer" }}
                  className={item?.value == activeTab ? "active" : ""}
                  onClick={() => setActiveTab(item?.value)}
                >
                  {item?.lable}

                  {projectList[item?.value]?.length > 0 &&
                    ` (${projectList[item?.value]?.length})`}
                </li>
              ))}
            </ul>
            <div className="table-responsive ct_custom_table pt-2">
              <table className="table">
                <TableHeader data={projectHeader} />
                {paginatedList?.length > 0 && (
                  <tbody>
                    {paginatedList?.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item?.project_title || "#N/A"}</td>
                        <td>{item?.owner_name || "#N/A"}</td>
                        {item?.status != "pending" ? (
                          <StatusCol
                            type="projectContent"
                            status={item?.status}
                          />
                        ) : (
                          <td>
                            <select
                              className="form-control ct_input ct_fs_12 w-auto border-0 h-auto py-0"
                              id="project_categories"
                              onChange={(e) => {
                                handleUpdateStatus(e.target.value, item);
                              }}
                              value={item?.status}
                            >
                              <option value={"pending"}>Pending</option>
                              <option value={"approve"}>Approve</option>
                              <option value={"dismiss"}>Dismiss</option>
                            </select>
                          </td>
                        )}
                        <td>{pipViewDate(item?.created_at) || ""}</td>
                        <td>
                          <div className="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(fetchProjectDetails({
                                    payload: item?.id,
                                  }));
                                  dispatch(fetchProjectUploadeableDetails({
                                    payload: item?.id
                                  }));
                                }}
                              >
                                <a className="dropdown-item">
                                  View Details
                                </a>
                              </li>
                              {item?.is_admin &&
                                <li
                                  onClick={() => {
                                    console.log({ item })
                                    setSelectProject(item?.id)
                                    setIsUpload(true)
                                  }}
                                >
                                  <a className="dropdown-item">
                                    Upload Deliverable
                                  </a>
                                </li>
                              }
                              {item?.status != "completed" && item?.status != "pending" && item?.status != "dismissed" &&
                                <li>
                                  <a
                                    className="dropdown-item"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate(adminPaths?.InviteProject, {
                                        state: { id: item?.id },
                                      });
                                    }}
                                  >
                                    Invite Freelancer
                                  </a>
                                </li>
                              }
                              {/*
                              <li>
                                <a
                                  className="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"
                                >
                                  Send Message{" "}
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  onClick={() => setId(item?.content_id)}
                                  data-bs-target="#ct_remove_content"
                                  data-bs-toggle="modal"
                                >
                                  Remove{" "}
                                </a>
                              </li> */}
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>

              {paginatedList?.length <= 0 && <NoRecord />}
            </div>
            {paginatedList?.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-4 ">
                <div>
                  <PaginationDropdown
                    onChange={(val) => {
                      setListPerPages(val);
                      setCurrentPage(0);
                    }}
                  />
                </div>
                <div>
                  <ReactPagination
                    pageCount={Math.ceil(
                      projectList[activeTab]?.length / listPerPages
                    )}
                    onPageChange={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {
        isAddProject && (
          <AddProject
            onClose={() => setIsAddProject(false)}
            isAdmin={true}
            handleEditAddroject={handleEditAddroject}
          />
        )
      }

      {
        isViewProjectDetails && (
          <ProjectDetails
            onClose={() => {
              dispatch(setIsViewProjectDetails(false));
            }}
            setProjectId={setProjectId}
            setConfirmation={setConfirmation}
            deliveableList={deliveableList}
          />
        )
      }
      {
        confirmation &&
        <MarkCompleteConfirmationModal
          onClose={() => setConfirmation(false)}
          projectId={projectId}
          handleMarkAsComplete={(data) => handleMarkAsComplete(data)}
        />
      }
      {
        isSuccess &&
        <MarkAsCompleteModal
          onClose={() => setIsSuccess(false)}
        />
      }
      {
        isUpload &&
        <UploadDeliveableModal
          onClose={() => setIsUpload(false)}
          handleUploadDeliveablesData={handleUploadDeliveablesData}
        />
      }
    </AdminLayout >
  );
};

export default JobProjects;